import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sidebar } from '../../shared/components/sidebar/sidebar';
import { Navbar } from '../../shared/components/navbar/navbar';
import { EmptyState } from '../../shared/components/empty-state/empty-state';
import { TimelineChain, TimelineEntry, VersionControl } from '../../core/services/version-control';

function day(iso: string | null): string | null {
  return iso ? new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }) : null;
}

/** "3 Mar 2012 to 1 Jun 2020", "1 Jun 2020 to now"; "date unknown" where a document had no date. */
export function periodLabel(entry: Pick<TimelineEntry, 'validFrom' | 'validTo' | 'isCurrent'>): string {
  const from = day(entry.validFrom) ?? 'date unknown';
  const to = entry.isCurrent ? 'now' : day(entry.validTo) ?? 'date unknown';
  return `${from} to ${to}`;
}

/**
 * Facts kept as history: each chain is a sentence and the ones that followed it, linked by
 * "Both true, at different times" decisions on the Version Review page. Read-only.
 */
@Component({
  selector: 'app-version-timeline',
  standalone: true,
  imports: [CommonModule, Sidebar, Navbar, EmptyState],
  templateUrl: './version-timeline.html',
  styleUrl: './version-timeline.css'
})
export class VersionTimelinePage implements OnInit {
  private versionControl = inject(VersionControl);

  chains = signal<TimelineChain[]>([]);
  loading = signal(true);
  error = signal<string | null>(null);
  readonly periodLabel = periodLabel;

  ngOnInit(): void {
    this.versionControl.timeline().subscribe({
      next: chains => { this.chains.set(chains); this.loading.set(false); },
      error: () => { this.error.set('Could not load the timeline. Please try again.'); this.loading.set(false); }
    });
  }
}
